// アプリケーションのエントリーポイント
// 依存関係を削除して単純化

// Reactアプリケーションのエントリーポイント
import "./react/index.jsx"

// デバッグ用
console.log('JavaScript loaded')

// Turbo検出
document.addEventListener("turbo:load", function() {
  console.log('Turbo:load event fired in application.js')
  window.turboLoadFired = true;
});

// バックアップ：DOMContentLoadedイベント
document.addEventListener("DOMContentLoaded", function() {
  console.log('DOMContentLoaded event fired in application.js')
});

